import PropTypes from 'prop-types';
import React from 'react';
import diff from 'object-diff';
import PropertyDetailsView from './PropertyDetailsView';
import PropertyDetailsForm from './PropertyDetailsForm';

function getInitialValues(hotel) {
  const initialValues = hotel;
  initialValues.tax_rate = hotel.tax_rate
    ? Number(hotel.tax_rate * 100.0).toFixed(3)
    : hotel.tax_rate;
  return initialValues;
}

class PropertyDetails extends React.Component {
  constructor() {
    super();
    this.state = {
      isEditing: false,
    };
    this.handleEdit = this.handleEdit.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleEdit() {
    this.setState({ isEditing: true });
  }
  handleClose() {
    this.setState({ isEditing: false });
  }
  handleSubmit(values) {
    const changedValues = diff(this.props.hotel, values);
    if (changedValues.tax_rate) {
      changedValues.tax_rate = Number(changedValues.tax_rate / 100.0).toFixed(3);
    }
    this.props.editHotel(this.props.hotel.id, changedValues);
    this.handleClose();
  }
  render() {
    if (this.state.isEditing) {
      return (
        <PropertyDetailsForm
          {...this.props}
          onSubmit={this.handleSubmit}
          handleEdit={this.handleEdit}
          initialValues={getInitialValues(this.props.hotel)}
          handleClose={this.handleClose}
        />
      );
    }
    return <PropertyDetailsView {...this.props} handleEdit={this.handleEdit} />;
  }
}
PropertyDetails.propTypes = {
  hotel: PropTypes.object.isRequired,
  editHotel: PropTypes.func.isRequired,
};

export default PropertyDetails;



// WEBPACK FOOTER //
// src/routes/hotels/components/PropertyDetails.js